import { gql } from '@apollo/client';

export const ChangeInitialMessage = gql`
    mutation changeInitialMessage($initialMessage: String!, $agentId: ID!) {
        changeInitialMessage(initialMessage: $initialMessage, agentId: $agentId) {
            ... on SuccessType {
                message
            }

            ... on ErrorType {
                message
            }
        }
    }
`;
